export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_brand-boost-ads-1/artifacts/1977569590387a19_da3189ea-1da6-44cd-b7a9-cc6b889944a0.png";

export const IMG = {
  heroAbstract:
    "https://images.unsplash.com/photo-1790266117282-c952c8368cfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGJyaWdodCUyMGJsdWUlMjBjbG9jayUyMDNkfGVufDB8fHx8MTc5MjU2OTIzMXww&ixlib=rb-4.1.0&q=85",
  team: "https://images.pexels.com/photos/6476257/pexels-photo-6476257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  office:
    "https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMGFnZW5jeSUyMG9mZmljZSUyMHRlYW18ZW58MHx8fHwxNzkyNTY5MjMxfDA&ixlib=rb-4.1.0&q=85",
  videoEditing:
    "https://images.unsplash.com/photo-1627244714766-94dab62ed964?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHx2aWRlbyUyMGVkaXRpbmclMjBzdHVkaW98ZW58MHx8fHwxNzkyNTY5MjMxfDA&ixlib=rb-4.1.0&q=85",
  webDesign:
    "https://images.pexels.com/photos/36571389/pexels-photo-36571389.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  eventPhoto:
    "https://images.unsplash.com/photo-1565035010268-a3816f98589a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxldmVudCUyMHBob3RvZ3JhcGh5JTIwY29uY2VydHxlbnwwfHx8fDE3OTI1NjkyMzF8MA&ixlib=rb-4.1.0&q=85",
  dslr:
    "https://images.pexels.com/photos/12548528/pexels-photo-12548528.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  seo: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxtYXJrZXRpbmclMjBhbmFseXRpY3N8ZW58MHx8fHwxNzkyNTY5MzU1fDA&ixlib=rb-4.1.0&q=85",
  seoAlt:
    "https://images.pexels.com/photos/7413936/pexels-photo-7413936.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  social:
    "https://images.pexels.com/photos/147413/twitter-facebook-together-exchange-of-information-147413.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  socialAlt:
    "https://images.unsplash.com/photo-1603189751032-7d5b09d9c8ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMGFnZW5jeSUyMG9mZmljZXxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
  ppc: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtYXJrZXRpbmclMjBhbmFseXRpY3N8ZW58MHx8fHwxNzkyNTY5MzU1fDA&ixlib=rb-4.1.0&q=85",
  ppcAlt:
    "https://images.unsplash.com/photo-1781246435700-afec19012b45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxtYXJrZXRpbmclMjBhbmFseXRpY3N8ZW58MHx8fHwxNzkyNTY5MzU1fDA&ixlib=rb-4.1.0&q=85",
  branding:
    "https://images.unsplash.com/photo-1600869009498-8d429f88d4f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxncmFwaGljJTIwZGVzaWduZXIlMjBtb25pdG9yJTIwaWxsdXN0cmF0b3J8ZW58MHx8fHwxNzkyNTcyMDEyfDA&ixlib=rb-4.1.0&q=85",
  brandingAlt:
    "https://images.unsplash.com/photo-1666698809123-44e998e93f23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMGFnZW5jeSUyMG9mZmljZXxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
  content:
    "https://images.unsplash.com/photo-1726594696307-5c582ba81e0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMGFnZW5jeSUyMG9mZmljZXxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
  contentAlt:
    "https://images.unsplash.com/photo-1603201667106-0e3e0ae584c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMGFnZW5jeSUyMG9mZmljZXxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
  case1:
    "https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  case2:
    "https://images.unsplash.com/photo-1666698809123-44e998e93f23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMGFnZW5jeSUyMG9mZmljZXxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
  case3:
    "https://images.pexels.com/photos/6224/hands-people-woman-working.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portrait1:
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
  portrait2:
    "https://images.pexels.com/photos/34381971/pexels-photo-34381971.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portrait3:
    "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTI1NjkzNTV8MA&ixlib=rb-4.1.0&q=85",
};

export const WHATSAPP_NUMBER = "919769108757";

export const SERVICES = [
  {
    title: "SEO",
    slug: "seo",
    image: IMG.seo,
    blurb:
      "Rank higher, get found faster. Technical audits, on-page optimisation and authority building that compound month after month.",
    tags: ["Technical SEO", "Keyword Strategy", "Link Building"],
  },
  {
    title: "Social Media Marketing",
    slug: "social-media-marketing",
    image: IMG.social,
    blurb:      "Scroll-stopping content and community management across Instagram, LinkedIn, YouTube and X — built around your brand voice.",
    tags: ["Content Calendars", "Community", "Influencer Collabs"],
  },
  {
    title: "Paid Ads (PPC)",
    slug: "paid-ads",
    image: IMG.ppc,
    blurb:
      "Google, Meta and programmatic campaigns engineered for ROAS. Every rupee tracked, every click accountable.",
    tags: ["Google Ads", "Meta Ads", "Retargeting"],
  },
  {
    title: "Branding",
    slug: "branding",
    image: IMG.branding,
    blurb:
      "Identity systems that stick — logo, voice, colour and story crafted into a brand people remember at 2am.",
    tags: ["Logo & Identity", "Brand Guidelines", "Naming"],
  },
  {
    title: "Content Marketing",
    slug: "content-marketing",
    image: IMG.content,
    blurb:
      "Blogs, scripts, newsletters and thought leadership that turn readers into believers and believers into buyers.",
    tags: ["Editorial Strategy", "Copywriting", "Email"],
  },
  {
    title: "Web Design",
    slug: "web-design",
    image: IMG.webDesign,
    blurb:
      "High-converting websites and landing pages — designed to impress, built to load fast and sell faster.",
    tags: ["UI/UX", "Landing Pages", "E-commerce"],
  },
  {
    title: "AI Video Generation",
    slug: "ai-video-generation",
    image: IMG.heroAbstract,
    blurb:
      "Studio-grade video at machine speed. AI-powered avatars, product films and ad creatives generated on demand.",
    tags: ["AI Avatars", "Product Films", "Ad Creatives"],
  },
  {
    title: "Video Editing",
    slug: "video-editing",
    image: IMG.videoEditing,
    blurb:
      "Cuts that keep eyes glued — reels, YouTube edits, ads and brand films with pacing that performs.",
    tags: ["Reels & Shorts", "Brand Films", "Motion Graphics"],
  },
  {
    title: "Photography",
    slug: "photography",
    image: IMG.dslr,
    blurb:
      "Product, portrait and lifestyle photography with deliberate light and frames that make your brand look premium.",
    tags: ["Product Shoots", "Portraits", "Lifestyle"],
  },
  {
    title: "Event Photography",
    slug: "event-photography",
    image: IMG.eventPhoto,
    blurb:
      "Launches, conferences and celebrations captured live — every handshake, spotlight and standing ovation.",
    tags: ["Corporate Events", "Launches", "Concerts"],
  },
  {
    title: "Video Making",
    slug: "video-making",
    image: IMG.socialAlt,
    blurb:
      "Concept to final cut — scripting, shooting and producing videos that carry your story end to end.",
    tags: ["Scripting", "Production", "Direction"],
  },
];

export const CASE_STUDIES = [
  {
    image: IMG.case1,
    client: "Verve Fitness Co.",
    title: "From local gym to national franchise buzz",
    result: "+412% organic traffic",
    tags: ["SEO", "Content"],
  },
  {
    image: IMG.case2,
    client: "Kaya Naturals",
    title: "A rebrand that tripled shelf pickup",
    result: "3.1x brand recall",
    tags: ["Branding", "Photography"],
  },
  {
    image: IMG.case3,
    client: "Nimbus Fintech",
    title: "Performance ads at half the industry CPA",
    result: "5.8x ROAS",
    tags: ["PPC", "Video"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Brand Mitra 24 rebuilt our funnel end to end. Leads doubled in ninety days — and they answer at midnight. Literally around the clock.",
    name: "Aarav Mehta",
    role: "Founder, Verve Fitness Co.",
  },
  {
    quote:
      "The AI video work alone paid for the retainer. We ship ten ad creatives a week now without a studio day.",
    name: "Sana Kapoor",
    role: "CMO, Nimbus Fintech",
  },
  {
    quote:
      "They treat our brand like their own. Sharp strategy, bolder creative, zero missed deadlines.",
    name: "Rohan Iyer",
    role: "Director, Kaya Naturals",
  },
];

export const STATS = [
  { value: "250+", label: "Projects delivered" },
  { value: "98%", label: "Client retention" },
  { value: "11", label: "Services under one roof" },
  { value: "24/7", label: "Creative thinking" },
];
